import { Box } from '@qwealth/qcore';
import { WarningBox } from '../PreviewCard/NotesPreviewCardStyles';
import { BsFillExclamationTriangleFill } from 'react-icons/bs';

const WealthboxWarningMessage: React.FC = () => (
  <WarningBox
    borderRadius="default"
    marginTop="default"
    height="100px"
    width="100%"
    display="flex"
    flexDirection="row"
  >
    <Box height="100%" width="10px" backgroundColor="warning" borderLeft="default" />
    <Box
      display="flex"
      flexDirection="column"
      padding="default"
      marginLeft="large"
      justifyContent="center"
    >
      <Box display="flex" flexDirection="row" fontWeight="bold" gap="default" color="warning">
        <BsFillExclamationTriangleFill size="22px" />
        <Box color="dark" alignItems="bottom">
          WealthBox Conflict
        </Box>
      </Box>
      <Box>
        A conflict with Wealthbox has created a duplicate of this email note. Use the dropdown at
        the top to view other versions.
      </Box>
    </Box>
  </WarningBox>
);

export default WealthboxWarningMessage;
